// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e302f279","456":"a2ffc68d","765":"6d7f6858"}[chunkId] + ".chunk.js";
};